export const MIC_PREVIEW_SIGNAL_DB_THRESHOLD = -58

const SILENCE_DB = -100
const METER_DB_FLOOR = -78

interface AnalyserMeterReading {
	dbApprox: number
	meterPercent: number
	waveformPeak01: number
}

function dbFsToMeterPercent(rawDb: number): number {
	if (!Number.isFinite(rawDb) || rawDb <= METER_DB_FLOOR) {
		return 3
	}
	const capped = Math.min(0, rawDb)
	const t = (capped - METER_DB_FLOOR) / (0 - METER_DB_FLOOR)
	return Math.min(100, Math.max(4, t * 100))
}

export function readAnalyserMeter(analyser: AnalyserNode): AnalyserMeterReading {
	const length = analyser.fftSize
	const buf = new Float32Array(length)
	analyser.getFloatTimeDomainData(buf)

	let sumSq = 0
	let peakAbs = 0
	for (let i = 0; i < length; i++) {
		const s = buf[i] ?? 0
		const a = Math.abs(s)
		if (a > peakAbs) {
			peakAbs = a
		}
		sumSq += s * s
	}

	const rms = Math.sqrt(sumSq / length)
	const levelLinear = Math.max(rms, peakAbs * 0.5)

	const rawDb = levelLinear > 1e-8 ? 20 * Math.log10(levelLinear) : SILENCE_DB
	const dbApprox = Math.max(SILENCE_DB, Math.min(0, rawDb))

	return {
		dbApprox,
		meterPercent: dbFsToMeterPercent(rawDb),
		waveformPeak01: Math.min(1, Math.max(levelLinear * 6, peakAbs)),
	}
}
